import { IColumn } from '../../types';
import { defaultHeaderRenderer } from '../../headers';
import { TableCellProps } from '../../../types';
import { memo } from 'react';
import { EApplicationPGKeys, FeeStatus } from 'api-paths-cas';
import { UNKNOWN_VALUE } from '../helpers';
import { Flex } from '@chakra-ui/react';

const Formatter = memo(function formatter(cellProps: TableCellProps) {
  const getFeeStatus = (): string => {
    switch (cellProps.row.feeStatus) {
      case FeeStatus.Home:
        return 'Home';
      case FeeStatus.Overseas:
        return 'Overseas';
      case FeeStatus.NotSure:
        return 'Unsure';
      default:
        return UNKNOWN_VALUE;
    }
  };
  return (
    <Flex height="100%" width="100%" flexDirection={'column'}>
      {getFeeStatus()}
    </Flex>
  );
});

export const FeeStatusColumn = (): IColumn => ({
  item: {
    key: EApplicationPGKeys.FEE_STATUS,
    name: 'Fee status',
    headerRenderer: defaultHeaderRenderer,
    width: 'minmax(128px, 1fr)',
    sortable: true,
    formatter: Formatter,
  },
  visible: () => true,
});
